export const TRACKING_EVENTS = {
    PAGES: {
        PROPERTY_LIST: 'PropertyList',
        PROPERTY_DETAIL: 'PropertyDetail',
        PROPERTY_EDIT: 'PropertyEdit',
        PROPERTY_NEW: 'PropertyNew',
        PROJECT_LIST: 'ProjectList',
        PROJECT_DETAIL: 'ProjectDetail',
        PROJECT_EDIT: 'ProjectEdit',
        PROJECT_NEW: 'ProjectNew',
        DEMAND_LIST: 'DemandList',
        DEMAND_DETAIL: 'DemandDetail',
        DEMAND_EDIT: 'DemandEdit',
        DEMAND_NEW: 'DemandNew',
        PERSON_LIST: 'PersonList',
        PERSON_DETAIL: 'PersonDetail',
        PERSON_EDIT: 'PersonEdit',
        PERSON_NEW: 'PersonNew',
        TASK_LIST: 'TaskList',
        TASK_DETAIL: 'TaskDetail',
        TASK_EDIT: 'TaskEdit',
        TASK_NEW: 'TaskNew',
        GLOBAL: 'Global',
        DASHBOARD: 'Dashboard',
        UPDATE_INTERNET: 'UpdateInternet',
        MEDIA_STATIC: 'MediaStatic',
        MAIN_TABLE: 'ListModuleTable',
        SMART_SEARCH: 'SmartSearch',
        FAVOURITE: 'Favourite',
        HISTORY: 'History',
        PROPERTY_SEARCH: 'PropertySearch',
        PERSON_SEARCH: 'PersonSearch',
        PROPERTY_SEARCH_RESULT: 'PropertySearchResult',
        PERSON_SEARCH_RESULT: 'PersonSearchResult',
        DEMAND_SEARCH: 'DemandSearch',
        PROPERTY_CONTEXT_MENU: 'PropertyContextMenu',
        PERSON_CONTEXT_MENU: 'PersonContextMenu',
        DEMAND_CONTEXT_MENU: 'DemandContextMenu',
        TASK_CONTEXT_MENU: 'TaskContextMenu'

    },
    EVENTS: {
        SELECT_MAIN_MENU: 'SelectMainMenu',
        SELECT_TAB_VIEW: 'SelectTabView',
        CHANGE_LANGUAGE: 'ChangeLanguage', 
        OPEN_NOTIFICATION: 'OpenNotification',
        SELECT_USER_SETTING: 'SelectUserSettingItem',

        SUBMIT_DATA_FORM: 'SubmitData',
        SAVE_CHANGE_DATA_FORM: 'SaveChange',
        CANCEL_UPDATE: 'CancelUpdate',
        SEND_MESSAGE: 'SendMessageClick',
        SEND_SMS: 'SendSMSClick',
        CLONE: 'CloneClick',
        PRINT: 'PrintClick',
        NEW_HISTORY: 'NewHistoryClick',
        NEW_TASK: 'NewTaskClick',
        NEW_PROPERTY: 'NewPropertyClick',
        NEW_PROJECT: 'NewProjectClick',
        REFRESH_LIST: 'RefreshList',
        RECYCLE_BIN: 'RecycleBinClick',
        CHANGE_VIEW_MODE: 'ChangeViewMode',
        SEARCH_REGION_CLICK: 'SearchRegionClick',
        LIST_SEARCH_SELECT_SUGGESTION: 'ListSearchSelectSuggestion',
        CHANGE_FILTER: 'ChangeFilter',
        UPDATE_FILTER: 'UpdateFilter',
        NEW_FILTER: 'NewFilter',
        BULK_DELETE: 'BulkDelete',
        NEW_PERSON: 'NewPerson',
        NEW_COMPANY: 'NewCompany',
        NEW_DEMAND: 'NewDemand',
        NEW_APPOINTMENT: 'NewAppointment',
        NEW_SUPER_APPOINTMENT:'NewSuperAppointment',
        ADD_RELATION: 'AddRelation',
        SHARE_SOCIAL: 'ShareSocial',
        SWITCH_TAB: 'SwitchTab',
        NEW_PERSON_MODAL: 'NewPersonModal',
        EDIT_PERSON_MODAL: 'EditPersonModal',
        OPEN_DEMAND_MATCHING: 'OpenDemandMatching',
        OPEN_PROPERTY_MATCHING: 'OpenPropertyMatching',
        DATA_CHANGE_ACTION_REFRESH: 'DataChangeActionRefresh',
        DATA_CHANGE_ACTION_IGNORE: 'DataChangeActionIgnore',
        DELETE_ITEM: 'DeleteItem',

        MAIN_TABLE_CHANGE_PAGING_UPDATE: 'MainTableChangePagingUpdate',
        MAIN_TABLE_UPDATE_COLUMN_SETTING: 'MainTableUpdateColumnSetting',
        MAIN_TABLE_ACTION_CLICK: 'MainTableRowActionClick',
        MAIN_TABLE_ACTION_ROW_DOUBLE_CLICK: 'MainTableRowDoubleClick',
        MAIN_TABLE_ACTION_SORT: 'MainTableSort',


        GLOBAL_SEARCH_VIEW_RESULT: 'GlobalSearchViewResult',
        GLOBAL_SEARCH_EDIT_RESULT: 'GlobalSearchEditResult',
        GLOBAL_SEARCH_NEW_OBJECT: 'GlobalSearchNewObject',
        NEW_GLOBAL: 'NewGlobal',

        TABVIEW_SELECT_CONTEXT_MENU: 'TabviewSelectContextMenu',
        TABVIEW_CHANGE_TAB: 'TabviewChangeTab',
        TABVIEW_REMOVE_TAB:'TabviewRemoveTab',

        PROPERTY_LIST_NEW: 'NewProperty',
        PROPERTY_LIST_SEND_MAIL_RENTER: 'PropertySendMailRenter',
        PROPERTY_LIST_SEND_MAIL_OWNER: 'PropertySendMailOwner',
        
        SEARCH_SELECT_RECENT: 'SearchSelectRecent',
        SEARCH_BROWSE_BTN: 'SearchBrowseBtnClick',
        SEARCH_ADD_NEW: 'SearchAddNew',
        SEARCH_VIEW_DETAIL: 'SearchViewClick',
        SEARCH_EDIT: 'SearchEditClick',
        SEARCH_REMOVE: 'SearchRemoveClick'
    }
}